//  @flow

import React from 'react';

import Banner from './Banner';
import Info from './Info';
import Mission from './Mission';
import ExploreCourses from '../../Components/ExploreCourse';
import Meta from '../../Components/Meta';

import LazyComponent from '../../Components/LazyComponent';

import './style.css';

const AboutUs = () => (
  <main>
    <Meta
      title="About Us | Alien Brains Educations"
      description="Alien Brains Educations is one of the premier institutes having classroom like mentorship program for summer and winter online training programs under industry professionals."
    />
    <Banner />

    <LazyComponent>
      <Info />
    </LazyComponent>

    <LazyComponent>
      <Mission />
    </LazyComponent>

    <LazyComponent>
      <ExploreCourses />
    </LazyComponent>
  </main>
);

export default AboutUs;



// WEBPACK FOOTER //
// ./src/Pages/AboutUs/index.js